import { environmentManager } from '@tanstack/react-query'
import * as postgresHelpers from 'kysely/helpers/postgres'
import * as sqliteHelpers from 'kysely/helpers/sqlite'

export const { jsonArrayFrom, jsonObjectFrom } = environmentManager.isServer() ? postgresHelpers : sqliteHelpers
